import { Component, OnInit } from '@angular/core';
import {NotificationsService} from "../../../common/service/notifications.service";

@Component({
  selector: 'app-notifications-test',
  templateUrl: './notifications-test.component.html',
  styleUrls: ['./notifications-test.component.scss']
})
export class NotificationsTestComponent implements OnInit {

  constructor(private notificationMsg: NotificationsService) { }

  ngOnInit() {
  }

  sendAlert( id ){
    if (id === 1 ){
        this.notificationMsg.showAlert('alert introductory text 1','', 'push this to next', '/test/style');

    }
  }
}
